import { apiJson } from "./client";

/**
 * ✅ 서버 스펙:
 * POST /api/uploads/presign
 * body: { files: [ { filename: "a.mp4" } ] }
 * resp: { bucket, items:[ { filename, objectKey, putUrl } ] }
 *
 * ✅ 방어:
 * - objectKey/object_key/key 모두 허용
 */
export async function presignUploads(files) {
    const body = {
        files: (files || []).map((f) => ({ filename: f.name })),
    };
    const res = await apiJson("/api/uploads/presign", { method: "POST", body });

    // ok:false 형태도 방어
    if (res && res.ok === false) {
        throw new Error(res.message || "presign failed");
    }

    return res;
}

export function putToSignedUrl(putUrl, file, onProgress) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open("PUT", putUrl, true);

        xhr.upload.onprogress = (e) => {
            if (!onProgress) return;
            if (e.lengthComputable) onProgress(Math.round((e.loaded / e.total) * 100));
        };

        xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) resolve();
            else reject(new Error(`PUT failed: ${xhr.status}`));
        };
        xhr.onerror = () => reject(new Error("PUT failed: network error"));

        xhr.send(file);
    });
}
